import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import UpdatedByAndUpdatedAt from "../../../components/commons/CommonUpdatedByAndUpdatedAt";
import { formateDateTime } from "../../../utils/commonFunctions";
import { tableEditIcon } from "../../../assets/images";
import { ChecklistItemType } from "../../../commonTypes/jobsType";

type AppProps = {
  history: any;
  data: ChecklistItemType[] | [];
  header: TableHeadersType[];
  handleEdit: (id: string) => void;
  isEditJobChecklistPresent:boolean;
};

const JobsChecklistTableData = ({
  history,
  data,
  header,
  handleEdit,
  isEditJobChecklistPresent
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((dataItem: ChecklistItemType) => {
          return (
            <tr>
              {header?.map((headerData: TableHeadersType) => {
                if (headerData?.value === "title") {
                  return <td>{dataItem?.title}</td>;
                } else if (headerData?.value === "updated_by") {
                  return (
                    <td style={{ width: "180px" }}>
                      <UpdatedByAndUpdatedAt
                        firstName={dataItem?.updated_by?.first_name}
                        lastName={dataItem?.updated_by?.last_name}
                        profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                        updatedAt={formateDateTime(dataItem?.updated_at)}
                      />
                    </td>
                  );
                } else if (headerData?.value === "action") {
                  return (
                    <td>
                      {
                       isEditJobChecklistPresent ?  <span
                          className="d-inline-block pointer"
                          onClick={() => handleEdit(dataItem._id)}
                        >
                          <img src={tableEditIcon} alt="edit" />
                        </span> : null
                      }
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default JobsChecklistTableData;
